'use strict';

var _createForOfIteratorHelper = require("/codebuild/output/src122629992/src/niftron-profile/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createForOfIteratorHelper");

var _regeneratorRuntime = require("/codebuild/output/src122629992/src/niftron-profile/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator");

var _asyncToGenerator = require("/codebuild/output/src122629992/src/niftron-profile/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/asyncToGenerator");

var _classCallCheck = require("/codebuild/output/src122629992/src/niftron-profile/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/codebuild/output/src122629992/src/niftron-profile/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var Errors = require('interface-datastore').Errors;

var log = require('debug')('datastore:core:tiered');
/**
 * A datastore that can combine multiple stores. Puts and deletes
 * will write through to all datastores. Has and get will
 * try each store sequentially. Query will always try the
 * last one first.
 *
 */


var TieredDatastore = /*#__PURE__*/function () {
  function TieredDatastore(stores) {
    _classCallCheck(this, TieredDatastore);

    this.stores = stores.slice();
  }

  _createClass(TieredDatastore, [{
    key: "open",
    value: function () {
      var _open = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.prev = 0;
                _context.next = 3;
                return this.stores.map(function (store) {
                  return store.open();
                });

              case 3:
                _context.next = 8;
                break;

              case 5:
                _context.prev = 5;
                _context.t0 = _context["catch"](0);
                throw Errors.dbOpenFailedError();

              case 8:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this, [[0, 5]]);
      }));

      function open() {
        return _open.apply(this, arguments);
      }

      return open;
    }()
  }, {
    key: "put",
    value: function () {
      var _put = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(key, value) {
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.prev = 0;
                _context2.next = 3;
                return Promise.all(this.stores.map(function (store) {
                  return store.put(key, value);
                }));

              case 3:
                _context2.next = 8;
                break;

              case 5:
                _context2.prev = 5;
                _context2.t0 = _context2["catch"](0);
                throw Errors.dbWriteFailedError();

              case 8:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this, [[0, 5]]);
      }));

      function put(_x, _x2) {
        return _put.apply(this, arguments);
      }

      return put;
    }()
  }, {
    key: "get",
    value: function () {
      var _get = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3(key) {
        var _iterator, _step, store, res;

        return _regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _iterator = _createForOfIteratorHelper(this.stores);
                _context3.prev = 1;

                _iterator.s();

              case 3:
                if ((_step = _iterator.n()).done) {
                  _context3.next = 18;
                  break;
                }

                store = _step.value;
                _context3.prev = 5;
                _context3.next = 8;
                return store.get(key);

              case 8:
                res = _context3.sent;

                if (!res) {
                  _context3.next = 11;
                  break;
                }

                return _context3.abrupt("return", res);

              case 11:
                _context3.next = 16;
                break;

              case 13:
                _context3.prev = 13;
                _context3.t0 = _context3["catch"](5);
                log(_context3.t0);

              case 16:
                _context3.next = 3;
                break;

              case 18:
                _context3.next = 23;
                break;

              case 20:
                _context3.prev = 20;
                _context3.t1 = _context3["catch"](1);

                _iterator.e(_context3.t1);

              case 23:
                _context3.prev = 23;

                _iterator.f();

                return _context3.finish(23);

              case 26:
                throw Errors.notFoundError();

              case 27:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, this, [[1, 20, 23, 26], [5, 13]]);
      }));

      function get(_x3) {
        return _get.apply(this, arguments);
      }

      return get;
    }()
  }, {
    key: "has",
    value: function has(key) {
      var _this = this;

      return new Promise( /*#__PURE__*/function () {
        var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee5(resolve) {
          return _regeneratorRuntime.wrap(function _callee5$(_context5) {
            while (1) {
              switch (_context5.prev = _context5.next) {
                case 0:
                  _context5.next = 2;
                  return Promise.all(_this.stores.map( /*#__PURE__*/function () {
                    var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee4(store) {
                      var has;
                      return _regeneratorRuntime.wrap(function _callee4$(_context4) {
                        while (1) {
                          switch (_context4.prev = _context4.next) {
                            case 0:
                              _context4.next = 2;
                              return store.has(key);

                            case 2:
                              has = _context4.sent;

                              if (has) {
                                resolve(true);
                              }

                            case 4:
                            case "end":
                              return _context4.stop();
                          }
                        }
                      }, _callee4);
                    }));

                    return function (_x5) {
                      return _ref2.apply(this, arguments);
                    };
                  }()));

                case 2:
                  resolve(false);

                case 3:
                case "end":
                  return _context5.stop();
              }
            }
          }, _callee5);
        }));

        return function (_x4) {
          return _ref.apply(this, arguments);
        };
      }());
    }
  }, {
    key: "delete",
    value: function () {
      var _delete2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee6(key) {
        return _regeneratorRuntime.wrap(function _callee6$(_context6) {
          while (1) {
            switch (_context6.prev = _context6.next) {
              case 0:
                _context6.prev = 0;
                _context6.next = 3;
                return Promise.all(this.stores.map(function (store) {
                  return store.delete(key);
                }));

              case 3:
                _context6.next = 8;
                break;

              case 5:
                _context6.prev = 5;
                _context6.t0 = _context6["catch"](0);
                throw Errors.dbDeleteFailedError();

              case 8:
              case "end":
                return _context6.stop();
            }
          }
        }, _callee6, this, [[0, 5]]);
      }));

      function _delete(_x6) {
        return _delete2.apply(this, arguments);
      }

      return _delete;
    }()
  }, {
    key: "close",
    value: function () {
      var _close = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee7() {
        return _regeneratorRuntime.wrap(function _callee7$(_context7) {
          while (1) {
            switch (_context7.prev = _context7.next) {
              case 0:
                _context7.next = 2;
                return Promise.all(this.stores.map(function (store) {
                  return store.close();
                }));

              case 2:
              case "end":
                return _context7.stop();
            }
          }
        }, _callee7, this);
      }));

      function close() {
        return _close.apply(this, arguments);
      }

      return close;
    }()
  }, {
    key: "batch",
    value: function batch() {
      var batches = this.stores.map(function (store) {
        return store.batch();
      });
      return {
        put: function put(key, value) {
          batches.forEach(function (b) {
            return b.put(key, value);
          });
        },
        delete: function _delete(key) {
          batches.forEach(function (b) {
            return b.delete(key);
          });
        },
        commit: function () {
          var _commit = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee8() {
            var _iterator2, _step2, batch;

            return _regeneratorRuntime.wrap(function _callee8$(_context8) {
              while (1) {
                switch (_context8.prev = _context8.next) {
                  case 0:
                    _iterator2 = _createForOfIteratorHelper(batches);
                    _context8.prev = 1;

                    _iterator2.s();

                  case 3:
                    if ((_step2 = _iterator2.n()).done) {
                      _context8.next = 9;
                      break;
                    }

                    batch = _step2.value;
                    _context8.next = 7;
                    return batch.commit();

                  case 7:
                    _context8.next = 3;
                    break;

                  case 9:
                    _context8.next = 14;
                    break;

                  case 11:
                    _context8.prev = 11;
                    _context8.t0 = _context8["catch"](1);

                    _iterator2.e(_context8.t0);

                  case 14:
                    _context8.prev = 14;

                    _iterator2.f();

                    return _context8.finish(14);

                  case 17:
                  case "end":
                    return _context8.stop();
                }
              }
            }, _callee8, null, [[1, 11, 14, 17]]);
          }));

          function commit() {
            return _commit.apply(this, arguments);
          }

          return commit;
        }()
      };
    }
  }, {
    key: "query",
    value: function query(q) {
      return this.stores[this.stores.length - 1].query(q);
    }
  }]);

  return TieredDatastore;
}();

module.exports = TieredDatastore;